import {BaseConnectionParameter} from './BaseConnectionParameter';
import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class BaseConnection extends ConnectBasicEntity {
authConfigCode: string;
authMode: string;
description: TranslatedEmb;
host: string;
label: TranslatedEmb;
method: string;
parameters: {[key: string]: BaseConnectionParameter};
protocole: string;
}

